import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-loan-template-info',
  imports: [TranslatePipe],
  templateUrl: './loan-template-info.component.html',
  styleUrls: [
    './loan-template-info.component.scss',
    '../template-shared.stylesheet.scss',
  ],
})
export class LoanTemplateInfoComponent {
  translationPrefix = input('', { transform: appendPrefix });
}
function appendPrefix(value: string | undefined): string {
  return value + 'loan.';
}
